<template>
  <AppSection :title="params.message.title" class="section-popular-directions">
    <template #header_left v-if="params.header_left">
      <div v-html="params.header_left"></div>
    </template>
    <template #header_right v-if="params.header_right">
        <div class="headerRight">
            <div v-html="params.header_right"></div>
        </div>
    </template>
    <template #body>
      <slider-cards
          nav
          :params="{
                    slidesPerView: 4,
                    pagination: true,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.2,
                            spaceBetween: 20,
                        },
                        600: {
                            slidesPerView: 2.2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                        }
                    },
                }"
      >
        <swiper-slide v-for="(item, i) in params.items" :key="i">
          <direction-card v-bind="item"/>
        </swiper-slide>
      </slider-cards>
    </template>
  </AppSection>
</template>

<script>
import AppSection from '../AppSection.vue'
import DirectionCard from '../cards/DirectionCard.vue'
import SliderCards from '../SliderCards.vue'
import { SwiperSlide } from 'swiper/vue';
export default {
  name: "TeamSection",
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    AppSection,
    DirectionCard,
    SliderCards,
    SwiperSlide,
  },
  setup: (props, ctx) => {

    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.section-popular-directions {
  .swiper {
    &-pagination {
      display: none;
      @include mobile {
        display: block;
      }
    }
  }
}
.headerRight {
    @include desktopSm {
        padding-right: 150px;
    }

    @include tablet {
        padding-right: 100px;
    }

    @include mobile {
        padding-right: 0;
    }
}
</style>